import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "../../../../stories/Components/Card";
import { CardVariantsEnum } from "../../../../stories/Components/Card/interface";
import MixedGrid from "../../../../stories/Components/MixedGrid";
import { VTH_CARD_LAYOUTS } from "../../../../stories/Components/Card/Variants/VerticalToHorizontalCard/constants";
import VideoModal from "../../../VideoModal";
/**
 * @param {Object}
 * items: the contentItems to be displayed as cards
 * @returns {JSX.Element} The MixedCard layout component
 */

const MixedCardLayout = ({
    items = [],
    featureAttributionData = {},
    cardClickHandler = () => {},
    indexToFocus = null,
    startAt = 1,
}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [mediaItems, setMediaItems] = useState([]);
    const [playingVideoIndex, setVideoPlayingIndex] = useState(0);

    useEffect(() => {
        items
            .filter((_, index) => index < items.length)
            .map((item, index) => {
                if (item.itemType === "video") {
                    const mediaItem = {
                        ...item,
                        featureAttributionPosition: startAt + index,
                    };
                    setMediaItems((prev) => [...prev, mediaItem]);
                }
                return item;
            });
    }, [items]);

    if (!items.length) return;

    const handleClick = (item) => () => {
        const index = mediaItems.findIndex(
            (mediaItem) => mediaItem.id === item.id
        );
        setVideoPlayingIndex(index);
        setModalIsOpen(true);
    };

    const handleClose = () => {
        setModalIsOpen(false);
    };

    const getFeatureAttribution = (index, featureAttributionData) => {
        const featureAttribution = {
            name: "card-grid",
            position: index + 1,
        };
        if (featureAttributionData?.instance)
            featureAttribution.instance = featureAttributionData.instance;
        return featureAttribution;
    };

    const children = items
        .filter((_, index) => index < items.length)
        .map((item, index) => (
            <Card
                key={item.id + "-" + index}
                item={item}
                focus={index === indexToFocus}
                featureAttribution={getFeatureAttribution(
                    index,
                    featureAttributionData
                )}
                clickHandler={cardClickHandler}
                variant={CardVariantsEnum.VERTICAL_TO_HORIZONTAL}
                vthBreakpoints={
                    index === 0
                        ? VTH_CARD_LAYOUTS.MIXED_LAYOUT_PRIMARY_CARD
                        : VTH_CARD_LAYOUTS.MIXED_LAYOUT_SECONDARY_CARD
                }
                showDescription={index === 0}
                onClick={
                    mediaItems.length > 0 && item.itemType === "video"
                        ? handleClick(item)
                        : undefined
                }
            />
        ));

    return (
        <>
            <MixedGrid>{children}</MixedGrid>
            {mediaItems.length > 0 && (
                <VideoModal
                    isOpen={modalIsOpen}
                    handleClose={handleClose}
                    items={[mediaItems[playingVideoIndex]]}
                    playingVideoIndex={0}
                    featureAttributionName="card-grid"
                    aspectRatio="16:9"
                />
            )}
        </>
    );
};

MixedCardLayout.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    indexToFocus: PropTypes.number,
    featureAttributionData: PropTypes.shape({
        instance: PropTypes.string,
    }),
    cardClickHandler: PropTypes.func,
};

export default MixedCardLayout;
